export default __webpack_public_path__ + "static/media/masterclass_improvisation.88d2ceb8.pdf";